import { BadgeProps } from '@levelSystem/types';
import clsx from 'clsx';

const DefaultBadgeCore = ({ level, className }: BadgeProps) => (
    <img
        className={clsx('size-3 absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2', className)}
        src={`/static/img/level-system/default/badge-level-${level}.svg`}
    />
);

export { DefaultBadgeCore };
